const ccHolderForVerificationNameReducer = (state = '', action) => {
	switch(action.type){
	case 'CCHOLDERFORVERIFICATIONNAMEUPDATE':
		return action.payload;
	default:
		return state;
	}
}

export default ccHolderForVerificationNameReducer;